import React, { useState } from 'react';
import './TokenCalculator.css';

const MODEL_PRICING = {
  'gpt-3.5-turbo': { input: 0.0015, output: 0.002 }, // $ per 1K tokens
  'gpt-4': { input: 0.03, output: 0.06 },
  'gpt-4-turbo': { input: 0.01, output: 0.03 },
  'gpt-4o': { input: 0.005, output: 0.015 },
};

// Placeholder token estimation: 1 token ≈ 4 chars (for English)
function estimateTokens(text) {
  if (!text) return 0;
  return Math.ceil(text.length / 4);
}

const TokenCalculator = ({ onResult }) => {
  const [prompt, setPrompt] = useState('');
  const [outputTokens, setOutputTokens] = useState(500);
  const [model, setModel] = useState('gpt-4o');
  const [error, setError] = useState('');

  const handleCalculate = (e) => {
    e.preventDefault();
    const inputTokens = estimateTokens(prompt);
    const outTokens = parseInt(outputTokens, 10);
    if (isNaN(outTokens) || outTokens < 0) {
      setError('Please enter a valid output token count.');
      return;
    }
    setError('');
    const pricing = MODEL_PRICING[model];
    const inputCost = (inputTokens / 1000) * pricing.input;
    const outputCost = (outTokens / 1000) * pricing.output;
    const cost = inputCost + outputCost;
    onResult({
      prompt,
      inputTokens,
      outputTokens: outTokens,
      model,
      cost,
    });
  };

  const handleClearPrompt = () => setPrompt('');

  return (
    <form className="token-calc-form" onSubmit={handleCalculate}>
      <div className="form-title">Estimate Your GPT Token Cost</div>
      <div className="form-row textarea-row">
        <label htmlFor="prompt">Prompt</label>
        <div className="textarea-wrapper">
          <textarea
            id="prompt"
            value={prompt}
            onChange={e => setPrompt(e.target.value)}
            placeholder="Paste your prompt here..."
            rows={4}
            style={{ resize: 'vertical', minHeight: 80 }}
          />
          {prompt && (
            <button
              type="button"
              className="clear-btn"
              onClick={handleClearPrompt}
              aria-label="Clear prompt"
            >
              ×
            </button>
          )}
        </div>
      </div>
      <div className="form-row">
        <label htmlFor="outputTokens">Expected Output Tokens</label>
        <input
          id="outputTokens"
          type="number"
          min="0"
          value={outputTokens}
          onChange={e => setOutputTokens(e.target.value)}
          placeholder="e.g. 500"
        />
      </div>
      <div className="form-row">
        <label htmlFor="model">Model</label>
        <select
          id="model"
          value={model}
          onChange={e => setModel(e.target.value)}
        >
          <option value="gpt-3.5-turbo">GPT-3.5 Turbo</option>
          <option value="gpt-4">GPT-4</option>
          <option value="gpt-4-turbo">GPT-4 Turbo</option>
          <option value="gpt-4o">GPT-4o</option>
        </select>
      </div>
      {error && <div className="form-error">{error}</div>}
      <button className="calc-btn" type="submit">Calculate</button>
    </form>
  );
};

export default TokenCalculator; 